export enum DeviceTableTypeEnum {
  Players = "players",
  Peripherals = "peripherals",
}
